export interface CompletedSessions {
  courseName: string
  id: string
  parentName: string
}

export interface GetCompletedSessionsRequest {
  batchIds: Array<string>
  branchIds: Array<string>
  coachingCentreId: string
}

export interface Sessions {
  id: string
  sessionName: string
  startTime: string
  endTime: string
  subjectName: string
  sessionDate: string
  facultyName: string
  url?: string
  sessionRecordingUrl?: string
}

export interface GetSessionsRequest {
  batchIds: Array<string>
  branchIds: Array<string>
  coachingCentreId: string
  sessionTense?: string
  subjectId?: string
}

export interface GetCompletedSessionsResponse {
  completedSessions: Array<CompletedSessions>
}

export interface GetSessionsResponse {
  sessions: Array<Sessions>
  sessionTense?: string
  subjectId?: string
}

interface LiveState {
  isLoading: boolean
  completedSessions: Array<CompletedSessions>
  upComingSessions: Array<Sessions>
  liveSessions: Array<Sessions>
  sessionDetails: Array<Sessions>
}

export const initialState: LiveState = {
  isLoading: false,
  completedSessions: [],
  upComingSessions: [],
  liveSessions: [],
  sessionDetails: []
}
